/**
 * @file Identity tag selection actions.
 */
import pMap from 'p-map-browser';

import { getErrorString } from '../util/normalize-errors';
import { prepareIdentityTagsForCreate } from '../util/album-folder-tags';

export const SELECT_TAG = 'identity-tag-selection/SELECT_TAG';
export const DESELECT_TAG = 'identity-tag-selection/DESELECT_TAG';
export const UPDATED_TAG = 'identity-tag-selection/UPDATED_TAG';
export const CHECKOUT_TAG_SELECTION_REQUEST =
  'identity-tag-selection/CHECKOUT_TAG_SELECTION_REQUEST';
export const CHECKOUT_TAG_SELECTION_FAILURE =
  'identity-tag-selection/CHECKOUT_TAG_SELECTION_FAILURE';
export const CHECKOUT_TAG_SELECTION_SUCCESS =
  'identity-tag-selection/CHECKOUT_TAG_SELECTION_SUCCESS';
export const RESET_TAGS = 'identity-tag-selection/RESET_TAGS';

export const updatedTag = () => {
  return { type: UPDATED_TAG };
};

export const selectTag = (identity, tag) => {
  return { type: SELECT_TAG, identity, tag };
};

export const deselectTag = (identity, tag) => {
  return { type: DESELECT_TAG, identity, tag };
};

export const resetTagSelection = () => {
  return { type: RESET_TAGS };
};

const checkoutTagSelectionSuccess = () => {
  return { type: CHECKOUT_TAG_SELECTION_SUCCESS };
};

const checkoutTagSelectionRequest = () => {
  return { type: CHECKOUT_TAG_SELECTION_REQUEST };
};

const checkoutTagSelectionFailure = error => {
  return { type: CHECKOUT_TAG_SELECTION_REQUEST, error: getErrorString(error) };
};

export const checkoutTagSelection =
  identityAlbumFolderTagsCreateMutation => async (dispatch, getState) => {
    dispatch(checkoutTagSelectionRequest());
    const { identities } = getState().identityTagSelection;

    const identitiesForTagCreation = prepareIdentityTagsForCreate(identities);

    try {
      await pMap(
        identitiesForTagCreation,
        async identity => {
          await identityAlbumFolderTagsCreateMutation(identity);
        },
        { concurrency: 3 },
      );

      dispatch(checkoutTagSelectionSuccess());
    } catch (error) {
      dispatch(checkoutTagSelectionFailure(error));
    }
  };
